import type { ReactNode } from "react";

import { Button } from "@heroui/react";
import { ActionBar } from "@heroui-pro/react";
import { X } from "lucide-react";

/** The floating bar for the rows selected in a table: "N selected", the actions, and a clear button. */
export function BulkBar({
  count,
  children,
  onClear,
}: {
  count: number;
  children: ReactNode;
  onClear: () => void;
}) {
  return (
    <ActionBar
      aria-label="Bulk actions"
      className="bottom-20!"
      isOpen={count > 0}
    >
      <ActionBar.Prefix>
        <span className="text-sm font-medium tabular-nums">
          {count} selected
        </span>
      </ActionBar.Prefix>
      <ActionBar.Content>{children}</ActionBar.Content>
      <ActionBar.Suffix>
        <Button
          isIconOnly
          aria-label="Clear selection"
          size="sm"
          variant="ghost"
          onPress={onClear}
        >
          <X className="size-4" />
        </Button>
      </ActionBar.Suffix>
    </ActionBar>
  );
}
